import { Action } from 'redux';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { RemoveExternalContentAction } from './AppActionTypes';


export interface RemoveExternalContentAction extends Action {
  item: IContentInfo<'database'> | IContentInfo<'table'>;
}

export function removeExternalContentAction(item: IContentInfo<'database'> | IContentInfo<'table'>): RemoveExternalContentAction {
  return {
    type: RemoveExternalContentAction,
    item
  };
}
